import styled from "@emotion/styled";

import MobileQuizTimeLabel from "./mobile-quiz-time-label.svg?url";
import SvgQuizTimeLabel from "./quiz-time-label.svg?url";

export const Container = styled.div`
  position: relative;

  inline-size: 100%;
  max-inline-size: 446px;
  margin-inline: auto;

  ${props => props.theme.breakpoints.up("desktop")} {
    max-inline-size: none;
  }
`;

export const Wrapper = styled.div`
  position: relative;

  inline-size: 100%;
  min-block-size: 578px;

  border: 2px solid #000000;
  border-radius: 16px;

  overflow: hidden;
`;

export const QuizTimeLabel = styled.div`
  position: absolute;
  inset-block-start: -26px;
  inset-inline-start: 50%;
  z-index: 1;

  inline-size: 166px;
  block-size: 55px;

  background-image: url(${MobileQuizTimeLabel});
  background-repeat: no-repeat;
  background-size: contain;

  transform: translateX(-50%);

  ${props => props.theme.breakpoints.up("desktop")} {
    inset-block-start: -35px;
    inset-inline-start: -20px;

    inline-size: 219px;
    block-size: 82px;

    background-image: url(${SvgQuizTimeLabel});

    transform: translateX(0);
  }
`;
